import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Routes, Route } from 'react-router-dom';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';

import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import FormBasedContainer from "~common/form/form-based-container-fc";
import {ContainerTypeEditor} from "~common/form/form-based-container-fc";


const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
  match: any;
}

type State = {};

class ResetPasswordWithToken extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {};
	}

	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

	render() {
		
    const {match} = this.props;
		const { classes }: { classes: ClassNameMap } = this.props;

		return (
			<div className={classes.container}>
				<AppView history={this.props.history}>
					<DefinitionDataProvider>
						<FormBasedContainer
							containerType={ContainerTypeEditor} 
							history={this.props.history} 
							match={match}
							clearDataOnSubmit={true}
							hideCancelButton={true}
							dataUrl="/api/auth/users/reset"
							returnURL="/login"
							successMessage="Your password has been reset.  You will now be redirected to the login page."
							formSelector={{"formType": "resetPassword", "form": "resetPassword", "module": "auth"}}
						>
						</FormBasedContainer>
					</DefinitionDataProvider>
        </AppView>
			</div>
		);
	}
}

export default withStyles(styles)(ResetPasswordWithToken);

